<script>
    import {Bar, HorizontalBar, mixins} from 'vue-chartjs'
    import {mapGetters} from 'vuex'

    export default {
        extends: HorizontalBar,
        props:
            {
                options: {},
                dimensions: {},
                colorTheme: {},
                componentData: {},
                config: {
                    title: {
                        display: {
                            type: Boolean
                        },
                        position: {
                            type: String
                        },
                        fontSize: {
                            type: Number
                        },
                        fontColor: {
                            type: Color
                        },
                        text: {
                            type: String
                        }
                    },
                    stackedY: {
                        type: Boolean
                    },
                    stackedX: {
                        type: Boolean
                    },
                    gridLineY: {
                        type: Boolean
                    },
                    gridLineX: {
                        type: Boolean
                    },
                    gridlineColor: {
                        type: Color
                    },
                    showLegend: {
                        type: Boolean
                    }
                },
            },
        methods: {
            createDataSets(labels) {

                var self = this
                var dataCollections = []
                // these are the labels for the data sets (showing up in the legend)
                var dataCollectionLabels = _.uniq(_.map(this.componentData, this.dimensions[1]))
                // foreach data collection label
                //  push to a dataset to start with
                dataCollectionLabels.forEach((collectionLabel, idx) => {
                    dataCollections.push({
                        id: collectionLabel,
                        label: collectionLabel,
                        backgroundColor: self.colorTheme[idx],
                        data: new Array(labels.length).fill(0)
                    })
                })
                // foreach datacollection label
                // check if there is data, if so ++= the value from the given data set
                dataCollectionLabels.forEach((collectionLabel, idx) => {
                    _.find(this.componentData, function (compData) {
                        if (collectionLabel == compData[self.dimensions[1]]) {
                            var IndexToAdd = _.indexOf(labels, compData[self.dimensions[0]])
                            var indexOfCollection = _.indexOf(dataCollectionLabels, compData[self.dimensions[1]])
                            dataCollections[indexOfCollection].data[IndexToAdd] += compData.Value
                        }
                    });
                })

                return dataCollections
            },
            calculateChartData() {
                var labels = _.uniq(_.map(this.componentData, this.dimensions[0]))
                return {
                    labels: labels,
                    datasets: this.createDataSets(labels)
                }
            },
            getOptions() {
                var self = this
                return {
                    title: self.config.title,
                    spanGaps: true,
                    animation: {
                        duration: 0,
                        easing: 'easeOutCubic',
                        onProgress: (e) => {
                            if (!self.animationComplete) {

                            }
                        },
                        onComplete: () => {
                        }
                    },
                    tooltips: {
                        //https://www.chartjs.org/docs/latest/general/interactions/modes.html#interaction-modes
                        mode: 'point',
                        intersect: true,
                        position: 'nearest',
                        backgroundColor: "#1e1e2f",
                        titleSpacing: 5,
                        footerSpacing: 5,
                        bodySpacing: 10,
                        xPadding: 30,
                        yPadding: 30,
                        cornerRadius: 0,
                        multiKeyBackground: "#1e1e2f",
                        displayColors: true,
                        // Disable the on-canvas tooltip
                        enabled: true,
                        // titleFontColor: "#1e1e2f",
                        titleMarginBottom: 10,
                        bodySpacing: 7,
                        bodyFontSize: 15,
                        callbacks: {
                            title: function (tooltipItem, data) {
                                return null
                            },
                            // afterLabel: function (tooltipItem, data) {
                            //
                            //     const tooltip = data.datasets[tooltipItem.datasetIndex];
                            //     const value = tooltip.data[tooltipItem.index];
                            //     if (value == 0) {
                            //         return null
                            //     }
                            //
                            //     return " " + tooltip.dateRange
                            // },
                            // label: function (tooltipItem, data) {
                            //     var label = data.datasets[tooltipItem.datasetIndex].label || '';
                            //     const tooltip = data.datasets[tooltipItem.datasetIndex];
                            //     const value = tooltip.data[tooltipItem.index];
                            //
                            //     if (value == 0) {
                            //         return null
                            //     }
                            //     if (label) {
                            //         label += '  ' + self.dataSetUnit + " ";
                            //     }
                            //     label += Math.round(tooltipItem.yLabel * 100) / 100;
                            //     // label += " " + tooltip.dateRange
                            //     return " " + label;
                            // }
                        },
                        // custom: function (tooltipModel) {
                        //     // Tooltip Element
                        //     return;
                        //     var tooltipEl = document.getElementById('chartjs-tooltip');
                        //
                        //     // Create element on first render
                        //     if (!tooltipEl) {
                        //         tooltipEl = document.createElement('div');
                        //         tooltipEl.id = 'chartjs-tooltip';
                        //         tooltipEl.innerHTML = "<table></table>";
                        //         document.body.appendChild(tooltipEl);
                        //     }
                        //
                        //     // Hide if no tooltip
                        //     if (tooltipModel.opacity === 0) {
                        //         tooltipEl.style.opacity = 0;
                        //         return;
                        //     }
                        //
                        //     // Set caret Position
                        //     tooltipEl.classList.remove('above', 'below', 'no-transform');
                        //     if (tooltipModel.yAlign) {
                        //         tooltipEl.classList.add(tooltipModel.yAlign);
                        //     } else {
                        //         tooltipEl.classList.add('no-transform');
                        //     }
                        //
                        //     function getBody(bodyItem) {
                        //         return bodyItem.lines;
                        //     }
                        //
                        //     // Set Text
                        //     if (tooltipModel.body) {
                        //         var titleLines = tooltipModel.title || [];
                        //         var bodyLines = tooltipModel.body.map(getBody);
                        //
                        //         var innerHtml = '<thead>';
                        //
                        //         titleLines.forEach(function (title) {
                        //             innerHtml += '<tr><th>' + title + '</th></tr>';
                        //         });
                        //         innerHtml += '</thead><tbody>';
                        //
                        //         bodyLines.forEach(function (body, i) {
                        //             var colors = tooltipModel.labelColors[i];
                        //             var style = 'background:' + colors.backgroundColor;
                        //             style += '; border-color:' + colors.borderColor;
                        //             style += '; border-width: 2px';
                        //             var span = '<span style="' + style + '"></span>';
                        //             innerHtml += '<tr><td>' + span + body + '</td></tr>';
                        //         });
                        //         innerHtml += '</tbody>';
                        //
                        //         var tableRoot = tooltipEl.querySelector('table');
                        //         tableRoot.innerHTML = innerHtml;
                        //     }
                        //
                        //     // `this` will be the overall tooltip
                        //     var position = this._chart.canvas.getBoundingClientRect();
                        //
                        //     // Display, position, and set styles for font
                        //     tooltipEl.style.opacity = 1;
                        //     tooltipEl.style.position = 'absolute';
                        //     tooltipEl.style.left = position.left + window.pageXOffset + tooltipModel.caretX + 'px';
                        //     tooltipEl.style.top = position.top + window.pageYOffset + tooltipModel.caretY + 'px';
                        //     tooltipEl.style.fontFamily = tooltipModel._bodyFontFamily;
                        //     tooltipEl.style.fontSize = tooltipModel.bodyFontSize + 'px';
                        //     tooltipEl.style.fontStyle = tooltipModel._bodyFontStyle;
                        //     tooltipEl.style.padding = tooltipModel.yPadding + 'px ' + tooltipModel.xPadding + 'px';
                        //     tooltipEl.style.pointerEvents = 'none';
                        // }
                    },
                    scales: {
                        yAxes: [{
                            autoSkip: true,
                            stacked: self.config.stackedY,
                            id: 'left',
                            position: 'left',
                            beginAtZero: true,
                            gridLines: {
                                display: self.config.gridLineY,
                                color: self.config.gridlineColor,
                                // borderDash: ['red'],
                                // borderDashOffset: 0,
                                // lineWidth: 1,
                                drawBorder: false,
                                // drawOnChartArea: true,
                                // drawTicks: true,
                                // tickMarkLength: 10,
                                // zeroLineWidth: 1,
                                zeroLineWidth: 0,
                                zeroLineColor: 'rgba(0,0,0,0)',
                                // zeroLineBorderDash: [],
                                // zeroLineBorderDashOffset: 0,
                                // offsetGridLines: true,
                            },
                            ticks: {
                                beginAtZero: true,
                                min: 0,
                                // stepSize: this.stepSize,
                                callback: function (value, index, values) {
                                    return value
                                },
                                display: true,
                                fontColor: 'black',
                                //fontFamily: ''
                                //fontSize: 10,
                                // fontStyle: 'normal',
                                // reverse: false,
                                // minor: {
                                //callback: function (){ },
                                //fontColor: '#666,
                                //fontFamily: ''
                                //fontSize: 10,
                                // fontStyle: 'normal',
                                // },
                                // major: {
                                //callback: function (){ },
                                //fontColor: '#666,
                                //fontFamily: ''
                                //fontSize: 10,
                                // fontStyle: 'normal',
                                // }
                            },
                            scaleLabel: {
                                display: true,
                                // labelString: self.xDescription,
                                fontSize: 20
                            },
                        }
                        ],
                        xAxes: [
                            {
                                stacked: self.config.stackedX,

                                beginAtZero: true,
                                // type: "time",
                                // time: {
                                //     tooltipFormat: "MMMM Do YYYY, hh:mm:ss"
                                // },
                                // autoSkip: true,
                                // display: self.showXaxes(),
                                display: true,
                                drawBorder: false,
                                gridLines: {
                                    display: self.config.gridLineX,
                                    color: self.config.gridlineColor,
                                    // borderDash: ['red'],
                                    // borderDashOffset: 0,
                                    // lineWidth: 1,
                                    // drawBorder: false,
                                    // drawOnChartArea: true,
                                    // drawTicks: true,
                                    // tickMarkLength: 10,
                                    zeroLineWidth: 0,
                                    zeroLineColor: 'rgba(0,0,0,0)',
                                    // zeroLineBorderDash: [],
                                    // zeroLineBorderDashOffset: 0,
                                    // offsetGridLines: true,
                                },
                                ticks: {
                                    // autoSkip: false,
                                    beginAtZero: true,
                                    // min: 0,
                                    // stepSize: this.stepSize,
                                    //callback: function (){ },
                                    // display:true,

                                    //fontFamily: ''
                                    //fontSize: 10,
                                    // fontStyle: 'normal',
                                    // reverse: false,
                                    // minor: {
                                    //callback: function (){ },
                                    //fontColor: '#666,
                                    //fontFamily: ''
                                    //fontSize: 10,
                                    // fontStyle: 'normal',
                                    // },
                                    // major: {
                                    //callback: function (){ },
                                    //fontColor: '#666,
                                    //fontFamily: ''
                                    //fontSize: 10,
                                    // fontStyle: 'normal',
                                    // }
                                }
                            }]
                    },
                    legend: {
                        display: self.config.showLegend,
                        // legendTemplate: '<ul class="<%=name.toLowerCase()%>-legend"><% for (var i=0; i<segments.length; i++){%><li class="chapter__item"><span style="background-color:<%=segments[i].fillColor%>"></span><%if(segments[i].label){%><%=segments[i].label%><%}%></li><%}%></ul>',
                        position: 'bottom',
                        fullWidth: false,
                        usePointStyle: false,
                        labels: {
                            fontFamily: "'Open Sans', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif"
                        },
                        onClick: (evt, legendItem) => {
                            var index = legendItem.datasetIndex;
                            var ci = this.$data._chart;
                            var meta = ci.getDatasetMeta(index);

                            // See controller.isDatasetVisible comment
                            // normal behaviour
                            meta.hidden = meta.hidden === null ? !ci.data.datasets[index].hidden : null;
                            ci.update();
                        },
                        labels: {
                            fontColor: self.config.legendColor,
                        }
                    },
                    elements: {
                        line: {
                            tension: 0, // disables bezier curves
                        },
                    },
                    layout: {
                        padding: {
                            left: 0,
                            right: 0,
                            top: 10,
                            bottom: 10
                        }
                    },
                    onClick: function (event, data) {

                    },
                    hover: {
                        onHover: function (e, el) {
                            $("#bar-chart").css("cursor", el[0] ? "pointer" : "default");
                        }
                    },
                    responsive: true,
                    maintainAspectRatio: false,
                }
            },
            renderThatChart() {

                var options = this.getOptions()
                var chartData = this.calculateChartData()

                this.renderChart(chartData, options)
            }
        },
        computed: {},
        watch: {
            componentData: {
                handler: function () {
                    this.$data._chart.destroy()
                    this.renderThatChart()
                }, deep: true
            }
        },
        created() {

        },
        mounted() {

            this.renderThatChart()
        }
    }
</script>
